import React from "react";
import { Link, useNavigate } from "react-router-dom";

const FrontendFooter: React.FC = () => {
  const navigate = useNavigate();

  const handleCityClick = (city: string) => {
    navigate(`/lands?locality=${encodeURIComponent(city)}`);
  };
  return (
    <footer id="footer">
      <div className="tf-container">
        <div className="row">
          <div className="footer-main">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="footer-menu-list footer-col-block style-2">
                  <a href="index.html">
                    <img
                      id="logo_footer"
                      src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/logo.png`}
                      alt=""
                    />
                  </a>
                  <p className="mt-5">
                    Our team of real estate professionals have helped hundreds
                    of buyers, sellers and investors make decisions that they
                    feel were and continue to be right for them years down the
                    road. We measure success not by the sales volume that ranks
                    us among the top 1% of local agents, but by delivering
                    results and fulfilling the trust placed on us by clients. We
                    stand ready to serve you as your California real estate
                    team.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="footer-menu-list footer-col-block style-2">
                  <h5 className="title lh-30">Quick Links</h5>
                  <ul className="tf-collapse-content">
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact</Link>
                    </li>
                    <li>
                      <Link to="/faqs">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/disclaimer">Disclaimer</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="footer-menu-list footer-col-block style-2">
                  <h5 className="title lh-30">Top Cities</h5>
                  <ul className="tf-collapse-content">
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCityClick("Bhubaneswar");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Bhubaneswar
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCityClick("Cuttack");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Cuttack
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCityClick("Puri");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Puri
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCityClick("Brahmapur");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Brahmapur
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCityClick("Sambalpur");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Sambalpur
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCityClick("Baripada");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Baripada
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="footer-menu-list footer-col-block style-2">
                  <h5 className="title lh-30">Quick links</h5>
                  <table>
                    <tbody>
                      <tr>
                        <td width="20" className="p-0">
                          <i className="bi bi-telephone-fill"></i>
                        </td>
                        <td>
                          <p>0987654321</p>
                        </td>
                      </tr>
                      <tr>
                        <td width="20" className="p-0">
                          <i className="bi bi-envelope-at-fill"></i>
                        </td>
                        <td>
                          <p>info@orimark.com</p>
                        </td>
                      </tr>
                      <tr>
                        <td width="20" className="p-0">
                          <i className="bi bi-geo-fill"></i>
                        </td>
                        <td>
                          <p>
                            Plot - 2, Saheed Nagar,
                            <br />
                            Bhubaneswar-751007, <br />
                            Odisha, India
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="footer-bottom">
            <p>
              © Copyrights {new Date().getFullYear()}. Powered by{" "}
              <a
                href="https://orimarktechnologies.com/"
                target="_blank"
                rel="noreferrer"
              >
                Orimark Technologies Pvt. Ltd
              </a>
            </p>
            <div className="wrap-social">
              <div className="text-3 fw-6">Follow us</div>
              <ul className="tf-social">
                <li>
                  <a href="#">
                    <i className="bi bi-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="bi bi-twitter-x"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="bi bi-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Progress Circle */}
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: 307.919,
            }}
          />
        </svg>
      </div>
    </footer>
  );
};

export default FrontendFooter;
